(function() {
    var constants = {
        prefix: 'ixp-full-page-flow-',
        moveSectionDownSelector: '.ixp-full-page-flow-move-section-down',
        moveSectionUpSelector: '.ixp-full-page-flow-move-section-up',

        moveSectionDownWithResetSelector: '.ixp-full-page-flow-move-section-down-reset',
        moveSectionUpWithResetSelector: '.ixp-full-page-flow-move-section-up-reset',

        moveSlideNextSelector: '.ixp-full-page-flow-move-slide-next',
        moveSlidePreviousSelector: '.ixp-full-page-flow-move-slide-previous'
    };

    var statics = {
        onGetScaffolding: function(scaffoldingKey, builder, options) {
            var fullPageFlow = {
                scaffolding: builder.scaffoldContainer('Full-Page Flow')
            };

            var buildContainer = function(elementName, customClass) {
                var container = builder.scaffoldContainer(elementName);
                container.style.customClass = customClass;
                return container;
            };

            fullPageFlow.scaffolding.content.scaffolding = [
                buildContainer('Section 1', 'ixp-full-page-flow-section background-d'),
                buildContainer('Section 2', 'ixp-full-page-flow-section background-e')
            ];

            return {
                scaffolding : [fullPageFlow.scaffolding]
            };
        }
    };

    return window.ixp.runtime.components.register('full-page-flow', {
        initialize: function(options) {
            this.anchors =  this._getSectionNames();

            var el = this.$('.ixp-full-page-flow');
            this.paddingTop = el.css('padding-top');
            this.paddingBottom = el.css('padding-bottom');
        },

        onDocumentReady: function() {
            if (this.inStudio) {
                return true;
            }

            this.$('.ixp-full-page-flow-slide').css({'float': 'left'});

            // this was taken from fullPage's css. only do this in non-CS mode
            this.$('html, body').css({
                'margin': 0,
                'padding': 0,
                'overflow': 'hidden'
            });

            this.$el.fullpage({
                cssPrefix: 'ixp-full-page-flow-',
                anchors: this.anchors,
                navigation: this.fpf_navigation,
                navigationPosition: this.fpf_navigation_position ? constants.prefix + this.fpf_navigation_position : 'none',
                navigationTooltips: this.fpf_navigation_tooltips ? this.fpf_navigation_tooltips.split(',') : [],
                paddingTop: this.paddingTop || '3em',
                paddingBottom: this.paddingBottom || '10px',
                scrollDisabled: this.fpf_scroll_type === 'none',
                //[BC]: for easing to work on click events, need autoScrolling on, even if set to none.
                // scrollDisabled will prohibit the scrolling
                autoScrolling: this.fpf_scroll_type === 'auto' || this.fpf_scroll_type === 'none',

                scrollingSpeed: this.fpf_scrolling_speed,
                easing: this.fpf_scroll_easing,
                css3: false,
                afterLoad: this.$.proxy(this._onSectionEnter, this),
                onLeave: this.$.proxy(this._onSectionLeave, this)
            });

            if (this.fpf_scroll_type === 'none') {
                this.$.fn.fullpage.setAllowScrolling(false);
                this.$.fn.fullpage.setKeyboardScrolling(false);
            }

            if (!this.fpf_slide_navigation) {
                this.$('.ixp-full-page-flow-controlArrow').css({'display': 'none'});
            }

            this.$el.on('click' + this.eventNamespace, constants.moveSectionUpSelector, this.$.proxy(this.moveSectionUp, this, false));
            this.$el.on('click' + this.eventNamespace, constants.moveSectionUpWithResetSelector, this.$.proxy(this.moveSectionUp, this, true));
            this.$el.on('click' + this.eventNamespace, constants.moveSectionDownSelector, this.$.proxy(this.moveSectionDown, this, false));
            this.$el.on('click' + this.eventNamespace, constants.moveSectionDownWithResetSelector, this.$.proxy(this.moveSectionDown, this, true));
            this.$el.on('click' + this.eventNamespace, constants.moveSlideNextSelector, this.$.proxy(this.moveSlideNext, this));
            this.$el.on('click' + this.eventNamespace, constants.moveSlidePreviousSelector, this.$.proxy(this.moveSlidePrevious, this));

            this._triggerReflowedEvent();

            return true;
        },

        allowedDropTargets: function () {
            return ['Container', 'Column'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.onGetScaffolding(scaffoldingKey, builder, options);
        },

        moveSectionUp: function(reset, e) {
            e.preventDefault();
            if (reset) {
                var positions = this._getCurrentPositions();
                this.$.fn.fullpage.moveTo(Math.max(positions.currentSection - 1, 0), 0);
            } else {
                this.$.fn.fullpage.moveSectionUp();
            }
        },

        moveSectionDown: function(reset, e) {
            e.preventDefault();
            if (reset) {
                var positions = this._getCurrentPositions();
                this.$.fn.fullpage.moveTo(positions.currentSection + 1, 0);
            } else {
                this.$.fn.fullpage.moveSectionDown();
            }
        },

        moveSlideNext: function(e) {
            e.preventDefault();
            this.$.fn.fullpage.moveSlideRight();
        },

        moveSlidePrevious: function(e) {
            e.preventDefault();
            this.$.fn.fullpage.moveSlideLeft();
        },

        _getCurrentPositions: function() {
            var sectionIndex = 1;
            var $currentSlide = null;

            var me = this;
            this.$('.ixp-full-page-flow-section').each(function() {
                var $item = me.$(this);
                if ($item.hasClass('ixp-full-page-flow-active')) {
                    $currentSlide = $item;
                    return false;
                }
                sectionIndex++;
            });

            var slideIndex = 0;
            $currentSlide.find('.ixp-full-page-flow-slide').each(function() {
                if (me.$(this).hasClass('ixp-full-page-flow-active')) {
                    return false;
                }
                slideIndex++;
            });

            return {
                currentSection: sectionIndex,
                currentSlide: slideIndex
            }
        },

        _getSectionNames: function() {
            var $sections = this.$('.ixp-full-page-flow-section');
            var $namedElements = this.$('.ixp-full-page-flow-section[ixp-element-name]');

            var me = this;
            if ($sections.length === $namedElements.length) {
                return $sections.map(function() {
                    return me.$(this).attr('ixp-element-name');
                });
            }
            return this.fpf_anchors
                ? this.fpf_anchors.split(',')
                : $sections.map(function() {
                    return this.id.replace('ball_', '');
                });
        },

        _triggerReflowedEvent: function(context) {
            var component = context || this;
            component.$(document).trigger('ixp-view-reflowed');
        },

        _onSectionEnter: function() {
            if (this._reflowTimer) {
                clearInterval(this._reflowTimer);
                delete this._reflowTimer;
            }
            this._triggerReflowedEvent();
        },

        _onSectionLeave: function() {
            this._reflowTimer = setInterval(this._triggerReflowedEvent, 100, this);
        }
    });
})();
